export default __webpack_public_path__ + "static/media/logo-Idilio-Vistania-white.3ab1b98e.png";